import { Component, Input, OnInit } from '@angular/core';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { DynamicForm } from '@/components/form-builder/form-builder.types';
import { getFormBuilderObjectFactory } from '@/components/form-builder/utils/form-builder-factory';
import {
  DynaDocsModelStatusRepository,
  DynaDocsModelStatusRepositoryFactory,
} from '@/store/dac-general-params-state/dyna-docs-model-status-state/dyna-docs-model-status.repository';
import { DynaDocsModelStatusStore } from '@/store/dac-general-params-state/dyna-docs-model-status-state/dyna-docs-model-status.store';
import { getDynaDocsModelStatusFormObject } from './utils/dyna-docs-model-status.form-object';

@Component({
  selector: 'sm-dyna-docs-model-status-form',
  standalone: true,
  imports: [FormBuilderComponent],
  templateUrl: './dyna-docs-model-status-form.component.html',
})
export class DynaDocsModelStatusFormComponent implements OnInit {
  @Input() store?: DynaDocsModelStatusStore;
  @Input() dynaDocsModelOptions?: any[];

  repository?: DynaDocsModelStatusRepository;
  formObject: DynamicForm = getFormBuilderObjectFactory();

  ngOnInit() {
    this.buildFormObject();
  }

  private buildFormObject() {
    if (this.store && this.dynaDocsModelOptions) {
      this.repository = DynaDocsModelStatusRepositoryFactory.create(this.store);
      this.formObject = getDynaDocsModelStatusFormObject({
        store: this.repository,
        dynaDocsModelOptions: this.dynaDocsModelOptions,
      });
    }
  }
}
